import { fg } from '@confluence/feature-gating';

export const useIsBlogTreeUnderContentTreeFFEnabled = () => {
	// todo: remove this workaround and use directly within components.
	const workaround = fg('blog_tree_under_content_tree');
	return workaround;
};
